import { render, staticRenderFns } from "./StepDocument.vue?vue&type=template&id=1af51954&scoped=true&"
import script from "./StepDocument.vue?vue&type=script&lang=js&"
export * from "./StepDocument.vue?vue&type=script&lang=js&"
import style0 from "./StepDocument.vue?vue&type=style&index=0&id=1af51954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af51954",
  null
  
)

export default component.exports